import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withFirestore } from 'react-redux-firebase';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Col,
  Form,
  FormGroup,
  ListGroupItem,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Row,
} from 'shards-react';
import {
  createComplaint,
  updateComplaint,
} from '../../../../pages/Dashboard/Complaint/complaintActions';
import { uploadFile } from '../../../../pages/FileUpload/fileUploadActions';
import DateInput from '../../../form/DateInput';
import { EXPECTED } from '../../../form/expected.data';
import FileUploader from '../../../form/FileUploader';
import { REPLY_STATUS } from '../../../form/replyStatus.data';
import SelectInput from '../../../form/SelectInput';
import { STATE_DATA } from '../../../form/states.data';
import TelInput from '../../../form/TelInput';
import TextAreaInput from '../../../form/TextAreaInput';
import TextInput from '../../../form/TextInput';
import { email, fullName } from '../../../util/validation';
import { closeModal, openModal } from '../../modalActions';

const mapState = (state, ownProps) => ({
  initialValues: {
    userFullName: state.firebase.profile.userFullName
  },
  loading: state.async.loading,
  documents: state.firestore.ordered.documents,
  files: [],
  profile: state.firebase.profile,
});
const actions = {
  createComplaint,
  updateComplaint,
  openModal,
  closeModal,
  uploadFile,
};
const validate = combineValidators({
  companyName: isRequired('company name'),
  companyAddress1: isRequired('address 1'),
  companyAddress2: isRequired('address 2'),
  reportDate: isRequired('report date'),
  companyAddressState: isRequired('State'),
  companyAddressTown: isRequired('Town'),
  companyAddressPostCode: isRequired('post code'),
  complaintDetails: isRequired('complaint details'),
  incidentDate: isRequired('incident date'),
  expectedOutcome: isRequired('expected outcome'),
  replyStatus: isRequired('reply status'),
  estimated_loss: isRequired('estimated loss'),
  //companyTel: isRequired('company contact number')
});

class NewComplaintModal extends Component {

  state = {
    statesArray: STATE_DATA,
    expectedArray: EXPECTED,
    replyArray: REPLY_STATUS,
    documents: [],
    complaintId: this.props.firestore.collection('complaints').doc().id,
    files: [],
    addMoreFile: false,
    fileuploader: [],
  };

  handleCreateComplaint = async (values) => {
    if (this.state.files && this.state.files.length > 0) {
      values.files = this.state.files;
    }
    try {
      if (this.props.initialValues.id) {
        this.props.updateComplaint(values);
        this.props.closeModal();
      } else {
        values.id = this.state.complaintId;
        this.props.openModal('ComplaintConfirmationModal', {
          handleSubmit: this.props.createComplaint,
          closeModal: this.props.closeModal,
          values: values,
        });
      }
    } catch (error) {}
  };

  componentDidMount() {
    if (this.state.complaintId !== '') {
    } else {
      this.getComplaintId();
    }

  }

  componentWillUnmount() {
    //this.props.firestore.unsetListener({ collection: 'usedocuments' });
  }

  getFiles = (tempFiles) => {
    // console.log(tempFiles);
    let joined = this.state.files.concat(tempFiles[0]);
    this.setState({ files: joined }, () => console.log(this.state.files));
  };

  addFileUploader() {
    let newfileUploader = this.state.fileUploader;
    newfileUploader.push(
      <FileUploader
        uploadFile={uploadFile}
        complaintId={this.state.complaintId}
        setTempFiles={this.getFiles}
      />
    );
    this.setState({ fileUploader: newfileUploader });
    console.log(this.state.fileUploader);
  }

  render() {
    const { statesArray, expectedArray, replyArray } = this.state;
    const {
      closeModal,
      submitting,
      pristine,
      invalid,
      uploadFile,
      complaintId,
      loading,
      history,
      profile,
    } = this.props;

    return (
      <Modal
        className='col-md-8 col-lg-8'
        open={true}
        toggle={closeModal}
        fade={true}
        role='dialog'
      >
        <ModalHeader className='bg-primary1'>
          <Fragment>
            Add Complaint
            <span> Id : {complaintId}</span>
          </Fragment>
        </ModalHeader>

        <ModalBody>
          <Form>
            <ListGroupItem>
              <strong>Complaint Against Whom?</strong>

              <Row form>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='companyName'>Company / Seller's Name</label>
                    <Field
                      component={TextInput}
                      placeholder={'ABC Sdn Bhd'}
                      name='companyName'
                      type='text'
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <label htmlFor='companyEmail'>
                      Company / Seller's Email
                    </label>
                    <Field
                      component={TextInput}
                      name='companyEmail'
                      type='email'
                      validate={email}
                      placeholder={'abc@acb.com'}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='companyAddress1'>
                      Company / Seller's Address Line 1
                    </label>
                    <Field
                      component={TextInput}
                      type='text'
                      name='companyAddress1'
                      placeholder={''}
                    />
                  </FormGroup>
                </Col>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='companyAddress2'>
                      Company / Seller's Address Line 2
                    </label>
                    <Field
                      component={TextInput}
                      type='text'
                      name='companyAddress2'
                      placeholder={''}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md='4' className='form-group'>
                  <label htmlFor='companyAddressTown'>
                    Company / Seller's Town
                  </label>
                  <Field
                    component={TextInput}
                    name='companyAddressTown'
                    type='text'
                    placeholder={''}
                  />
                </Col>
                <Col md='6' className='form-group'>
                  <label htmlFor='companyAddressState'>
                    Company / Seller's State
                  </label>
                  <Field
                    component={SelectInput}
                    name='companyAddressState'
                    options={statesArray}
                    type='text'
                    placeholder={''}
                  />
                </Col>
                <Col md='2'>
                  <label htmlFor='companyAddressPostCode'>
                    Company / Seller's Post Code
                  </label>
                  <Field
                    name='companyAddressPostCode'
                    type='text'
                    component={TextInput}
                    placeholder={''}
                  />
                </Col>
              </Row>
              <Row>
                <Col className='form-group'>
                  <label htmlFor='companyTel'>
                    Company / Seller's Contact Number
                  </label>
                  <Field
                    name='companyTel'
                    type='tel'
                    component={TelInput}
                    placeholder='Enter a valid phone number with area code e.g: 07, 03'
                  />
                </Col>
              </Row>
            </ListGroupItem>
            <ListGroupItem>
              <strong>Complaint Details</strong>
              <div className='text-danger caption py-1'>
                Please provide full name as per IC. Otherwise, this complaint
                will not be entertained.

              </div>
              <Row form>
                <Col md='4' sm='12' className='form-group'>
                  <label htmlFor='userFullName'>Full Name </label>

                  <Field
                    component={TextInput}
                    name='userFullName'
                    autoComplete={false}
                    type='text'
                    placeholder={'Full Name as Per IC'}
                    validate={fullName}
                  />
                </Col>
              </Row>

              <Row form>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='complaintDetails'>Complaint</label>
                    <div className='text-danger caption py-1'>
                      Do not share any sensitive information such as nationalID,
                      credit card numbers and etc.
                    </div>
                    <Field
                      component={TextAreaInput}
                      rows={5}
                      type='textarea'
                      name='complaintDetails'
                      placeholder='I was cheated...'
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md='12' className='form-group'>
                  <FormGroup>
                    <label>Incident Date</label>
                    <Field
                      type='date'
                      name='incidentDate'
                      component={DateInput}
                    />
                  </FormGroup>
                </Col>
                <Col md='12' className='form-group'>
                  <FormGroup>
                    <label>Report Date</label>
                    <Field
                      type='date'
                      name='reportDate'
                      component={DateInput}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col className='form-group'>
                  <FormGroup>
                    <label>Estimated Loss, RM</label>
                    <Field
                      name='estimated_loss'
                      component={TextInput}
                      type='number'
                    />
                  </FormGroup>
                </Col>
                <Col className='form-group'>
                  <FormGroup>
                    <label>Reply Status</label>
                    <Field
                      name='replyStatus'
                      component={SelectInput}
                      options={replyArray}
                    />
                  </FormGroup>
                </Col>
                <Col className='form-group'>
                  <FormGroup>
                    <label>Expect Outcome</label>
                    <Field
                      name='expectedOutcome'
                      component={SelectInput}
                      options={expectedArray}
                      type='text'
                    />
                  </FormGroup>
                </Col>
              </Row>
            </ListGroupItem>
            <ListGroupItem>
              <strong>Attachments</strong>
              {this.state.files && this.state.files.length > 0
                ? this.state.files.map((document) => {
                    return <div key={document.name}> {document.name}</div>;
                  })
                : ''}
              <Row>
                <FileUploader
                  uploadFile={uploadFile}
                  complaintId={complaintId}
                  loading={loading}
                  setTempFiles={this.getFiles}
                />
              </Row>
            </ListGroupItem>
          </Form>
        </ModalBody>

        <ModalFooter>
          <div className='home-buttons d-flex w-100 justify-content-between'>
            <Button
              theme='danger'
              type='dismiss'
              onClick={() => {
                closeModal();
              }}
            >
              Cancel
            </Button>
            <Button
              theme='success'
              type='submit'
              onClick={this.props.handleSubmit(this.handleCreateComplaint)}
            >
              Submit
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default compose(
  connect(mapState, actions),
  withFirestore,
  reduxForm({ form: 'complaintForm', validate, enableReinitialize: true,})
)(NewComplaintModal);
